import { SphereGeometry, MeshBasicMaterial, Mesh } from 'three';

const geometry = new SphereGeometry(0.01, 6, 6);
const material = new MeshBasicMaterial({ color: 0xffff00 });
export const getStartPointMesh = () => new Mesh(geometry, material);
// startPointMesh.visible = false;
